import i18n from "@/core/plugins/i18n";

const { t } = i18n.global;

export enum AccountPermissionTypes {
  transfer = 1,
  appTrade = 2,
  ibTradeInfo = 3,
}

export const getPermissionTitle = (permission) => {
  return (
    {
      [AccountPermissionTypes.transfer]: t("title.transfer"),
      [AccountPermissionTypes.appTrade]: t("fields.appTrade"),
      [AccountPermissionTypes.ibTradeInfo]: t("fields.ibTradeInfo"),
    }[permission] || t("status.inactive")
  );
};

export const isAvailablePermission = (permission) => {
  if (AccountPermissionTypes[permission]) {
    return true;
  }
  return false;
};
